import React from "react";
import { InlineWidget } from "react-calendly";

export default function StepFourForm() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, #fdfdfd 0%, #e9f9f8 100%)",
        paddingTop: "110px", // space for fixed navbar
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          boxShadow: "0 4px 25px rgba(0,0,0,0.08)",
          borderRadius: "16px",
          overflow: "hidden",
          background: "#fff",
        }}
      >
        <InlineWidget
          url="https://calendly.com/marklowkey00/30min"
          styles={{
            height: "850px",
            width: "100%",
            border: "none",
          }}
        />
      </div>
    </div>
  );
}
